import { twMerge } from 'tailwind-merge';

import { IDailyDealsItem, IDailyDealsSale } from 'models/daily-deals/i-daily-deals';
import { TradeOfferStatus } from 'models/trade/i-trade-offer.interface';

import Badge from 'components/badge/Badge';
import Button from 'components/buttons/Button';
import SoldBadge from 'components/soldBadge/SoldBadge';

import { useCurrency } from 'hooks/useCurrency';

import SharesIcon from 'assets/currency.svg';

interface IDailyDealsOffer extends IDailyDealsItem {
  onPurchase: (activeSales: IDailyDealsSale[]) => void;
}

const DailyDealsSale = ({ allSales, currency: { id }, meta, onPurchase }: IDailyDealsOffer) => {
  const currency = useCurrency(id);

  const activeSales = allSales.filter(({ status }) => status === TradeOfferStatus.ACTIVE);

  const soldOut = activeSales.length === 0;

  return (
    <div className="tw-relative tw-border-0 tw-border-b tw-border-solid tw-border-backgroundColorLight tw-py-3 xl:tw-flex xl:tw-justify-between">
      {soldOut && <div className="tw-absolute tw-inset-0 tw-z-10 tw-bg-backgroundColorDark tw-opacity-50" />}
      <div className="tw-flex tw-items-center tw-justify-between tw-gap-7.5 lg:tw-gap-2 xl:tw-mr-4">
        <div className="tw-z-10 tw-w-[85px] xl:tw-mr-4">
          {soldOut ? (
            <SoldBadge className="tw-w-max tw-px-2.5 tw-py-px tw-text-lg" />
          ) : (
            <Badge
              text={`${activeSales.length} left`}
              twClassName="tw-lowercase tw-mr-3.5 tw-w-max tw-bg-backgroundColorLight tw-text-lg tw-rounded-lg tw-px-4 tw-font-semibold"
            />
          )}
        </div>
        <div className={twMerge('offer-label', 'tw-w-16 tw-min-w-[55px] tw-text-lg md:tw-text-xl xl:tw-min-w-[75px]')}>
          <img className="tw-h-6" src={SharesIcon} alt="shares" />
          {meta.amount}
        </div>
        <div className={twMerge('offer-label', 'tw-min-w-[30px] tw-text-lg md:tw-text-xl xl:tw-min-w-[100px]')}>
          <img className="tw-h-6" src={currency?.icon} alt={currency?.symbol} />
          {meta.price}
        </div>
      </div>
      <Button
        size="medium"
        twClassName="tw-w-full tw-mt-2.5 xl:tw-mt-0 tw-text-lg tw-h-8 tw-py-0.5 xl:tw-w-[120px]"
        onClick={() => onPurchase(activeSales)}
        disabled={soldOut}
        requireWeb3
      >
        Buy
      </Button>
    </div>
  );
};

export default DailyDealsSale;
